import { ArrowUpRight } from "lucide-react";
import { camp } from "@/data/camp";

function RegisterLink({ className = "", label = "REGISTER NOW", testId }) {
  const paused = !camp.registrationEnabled;
  const content = <><span>{label}</span><ArrowUpRight size={16} strokeWidth={2.2} aria-hidden="true" /></>;
  const sharedClassName = `register-link ${paused ? "registration-disabled" : ""} ${className}`;
  const sharedLabel = `${label} for ${camp.eventName}${paused ? " — registration temporarily paused" : ""}`;

  if (paused) {
    return <button className={sharedClassName} type="button" disabled aria-disabled="true" title={camp.registrationPausedMessage} data-testid={testId} aria-label={sharedLabel}>{content}</button>;
  }
  return <a className={sharedClassName} href={camp.registrationUrl} target="_blank" rel="noreferrer" data-testid={testId} aria-label={sharedLabel}>{content}</a>;
}

export default RegisterLink;
